import { render, staticRenderFns } from "./RelatorioNotificacaoPush.vue?vue&type=template&id=657134a4&scoped=true&"
import script from "./RelatorioNotificacaoPush.vue?vue&type=script&lang=js&"
export * from "./RelatorioNotificacaoPush.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioNotificacaoPush.vue?vue&type=style&index=0&id=657134a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657134a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VProgressCircular,VTab,VTabs,VTooltip})
